import axiosInstance from "../Axois";

export const Addtocart = async (body) => {
  try {
    const response = await axiosInstance.post("customer/cart/add", body);;
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const Deletecart = async (id) => {
    try {
      const response = await axiosInstance.put("customer/cart/item/remove", id);;
      return response.data;
    } catch (error) {
      return error?.response?.data;
    }
  };
  export const Updatecart = async (body) => {
    try {
      const response = await axiosInstance.put("customer/cart/item/update-quantity", body);;
      return response.data;
    } catch (error) {
      return error?.response?.data;
    }
  };
export const GetAllCart = async () => {
    try {
      const response = await axiosInstance.get("customer/cart/items");;
      return response.data;
    } catch (error) {
      return error?.response?.data;
    }
  };

  export const ClearlCart = async () => {
    try {
      const response = await axiosInstance.delete("customer/cart/clear");;
      return response.data;
    } catch (error) {
      return error?.response?.data;
    }
  };

  export const Create_Order = async (body) => {
    try {
      const response = await axiosInstance.post("customer/order/create",body);
      return response.data;
    } catch (error) {
      return error?.response?.data;
    }
  };

  export const verifyPayment = async (body) => {
    try {
      const response = await axiosInstance.post(`/customer/order/verify-payment`,body);
      return response.data;
    } catch (error) {
      return error?.response?.data;
    }
  };